import axios from "axios";
import config from "../../../utils/config/config";
import { getAuthData } from "../../storage/LocalStorage";


const postBatchEntry = async (API_URL, reqInfo) => {
    const data = { logs: reqInfo };
    const sessionId = getAuthData().auth.sessionId
    try {
        const response = await axios.post(API_URL, data, {
            headers: {
                sessionid: sessionId,
            },
        });
        console.log("Batch log entry added");
        return response.data;
    } catch (error) {
        console.log("Error in API request:  ", error)
        // console.error(`Error in API request: ${error.response ? error.response.data : error.message}`);
    }
};

const addLog = (reqInfo) => {
    const API_URL = `${config.gRPCURL}/grpc/utils.UtilsService/AddBatchLogEntry`;
    return postBatchEntry(API_URL, reqInfo);
};

const addBatchLogEntry = (reqInfo) => {
    const API_URL = `${config.gRPCURL}/grpc/utils.UtilsService/AddBatchLogEntry`;
    return postBatchEntry(API_URL, reqInfo);
};


export const BotLogsService = {
    addLog,
    addBatchLogEntry,
};

